import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Pagination } from 'react-bootstrap';

const AsignacionesPaginacion = ({
    pageNumber,
    totalPages,
    total,
    pageSize,
    loading,
    onPageChange
}) => {
    
    // Solo ocultamos si no hay datos Y no estamos cargando
    if (total === 0 && !loading) return null;

    const startItem = (pageNumber - 1) * pageSize + 1;
    const endItem = Math.min(pageNumber * pageSize, total);

    const generatePaginationItems = () => {
        const items = [];
        const maxVisible = 5; // Máximo número de páginas visibles
        
        // Primera página
        if (pageNumber > 2) {
            items.push(
                <Pagination.Item key={1} onClick={() => onPageChange(1)}>
                    1
                </Pagination.Item>
            );
            
            if (pageNumber > 3) {
                items.push(<Pagination.Ellipsis key="start-ellipsis" />);
            }
        }
        
        // Páginas alrededor de la actual
        const start = Math.max(1, pageNumber - 1);
        const end = Math.min(totalPages, pageNumber + 1);
        
        for (let i = start; i <= end; i++) {
            items.push(
                <Pagination.Item
                    key={i}
                    active={i === pageNumber}
                    onClick={() => onPageChange(i)}
                    disabled={loading}
                >
                    {i}
                </Pagination.Item>
            );
        }
        
        // Última página
        if (pageNumber < totalPages - 1) {
            if (pageNumber < totalPages - 2) {
                items.push(<Pagination.Ellipsis key="end-ellipsis" />);
            }
            
            items.push(
                <Pagination.Item key={totalPages} onClick={() => onPageChange(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }
        
        return items;
    };

    return (
        <Row className="mt-3 align-items-center">
            <Col md={6}>
                <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                    Mostrando {startItem} a {endItem} de {total} asignaciones
                </p>
            </Col>
            <Col md={6}>
                <Pagination className="justify-content-end mb-0" size="sm">
                    <Pagination.Prev
                        disabled={pageNumber === 1 || loading}
                        onClick={() => onPageChange(pageNumber - 1)}
                    />
                    
                    {generatePaginationItems()}
                    
                    <Pagination.Next
                        disabled={pageNumber === totalPages || loading}
                        onClick={() => onPageChange(pageNumber + 1)}
                    />
                </Pagination>
            </Col>
        </Row>
    );
};

AsignacionesPaginacion.propTypes = {
    pageNumber: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired
};

export default AsignacionesPaginacion;
